import React from "react";
import { useNavbarController } from "./useNavbarController";
import { navigationGroups as navConfig } from "./data/navConfig";
import { SidebarContent } from "./components/SidebarContent";
import { cn } from "@/lib/utils";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "../../components/ui/button";
import { Menu } from "lucide-react";

export const Navbar = () => {
  const {
    isCollapsed,
    toggleSidebar,
    navigate,
    isUserAdmin,
    isFundSelected,
    isReportingPeriodSelected,
    collapsedGroups,
    toggleGroupCollapse,
  } = useNavbarController();

  const navGroups = navConfig(
    isUserAdmin,
    isCollapsed,
    isFundSelected,
    isReportingPeriodSelected,
    collapsedGroups
  );

  return (
    <>
      {/* Mobile Navigation */}
      <div className="lg:hidden fixed top-4 left-4 z-50">
        <Sheet>
          <SheetTrigger asChild>
            <Button variant="outline" size="icon">
              <Menu className="h-5 w-5" />
              <span className="sr-only">Toggle menu</span>
            </Button>
          </SheetTrigger>
          <SheetContent side="left" className="p-0">
            <SidebarContent
              isCollapsed={false}
              toggleSidebar={toggleSidebar}
              navigate={navigate}
              navigationGroups={navGroups}
              isMobile={true}
              onToggleGroupCollapse={toggleGroupCollapse}
            />
          </SheetContent>
        </Sheet>
      </div>

      {/* Desktop Navigation */}
      <div
        className={cn(
          "hidden lg:block h-full bg-background border-r border-border transition-[width] duration-200 ease-in-out overflow-hidden",
          isCollapsed ? "w-[70px]" : "w-[270px]"
        )}
      >
        <SidebarContent
          isCollapsed={isCollapsed}
          toggleSidebar={toggleSidebar}
          navigate={navigate}
          navigationGroups={navGroups}
          isMobile={false}
          onToggleGroupCollapse={toggleGroupCollapse}
        />
      </div>
    </>
  );
};
